import React from 'react'
import PropTypes from 'prop-types'
import moment from 'moment'

const SubscribeSection = props => {
  const { profile } = props
  return (
    <div className="portlet light">
      <div className="portlet-title">
        <h4>Subscription details</h4>
      </div>
      <div className="portlet-body">
        <div className="table-scrollable table-scrollable-borderless">
          <table className="table table-hover table-light">
            <thead>
              <tr className="uppercase">
                <th>Start date</th>
                <th>Expiry date</th>
                <th>Package</th>
                <th>Period</th>
                <th>Amount</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>
                  {profile.subscription
                    ? moment(profile.subscription.createdAt).format('DD MMMM YYYY')
                    : '-'}
                </td>
                <td>
                  {profile.subscription
                    ? moment(profile.subscription.endDate).format('DD MMMM YYYY')
                    : '-'}
                </td>
                <td>
                  {profile.subscription
                    ? profile.subscription.subscriptionPlan.name
                    : 'Basic'}
                </td>
                <td>{profile.subscription ? profile.subscription.paymentPeriod : '-'}</td>
                <td>
                  {profile.subscription
                    ? `$${profile.subscription.subscriptionPlan.price}`
                    : '-'}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  )
}

SubscribeSection.propTypes = {}

export default SubscribeSection
